import React, { useState } from 'react';
import {
  HeroSection,
  TechnologySection,
  ServicesSection,
  AIAdoptionSection,
  WhyChooseSection,
  TestimonialsSection,
  CTASection,
  Footer,
} from '../sections';
import ContactModal from '../sections/ContactModal';

const HomePage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="flex flex-col items-center w-full min-h-screen bg-white overflow-x-hidden">
      <div className="w-full flex flex-col gap-[50px] sm:gap-[60px] md:gap-[80px] lg:gap-[100px] xl:gap-[119px]">
        <HeroSection onExploreServices={scrollToServices} />
        <TechnologySection />
        <ServicesSection />
        <AIAdoptionSection />
        <WhyChooseSection />
        <TestimonialsSection />
        <CTASection onContactClick={() => setIsContactModalOpen(true)} />
        <Footer />
      </div>
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
    </div>
  );
};

export default HomePage;
